import { render, staticRenderFns } from "./ProgramDownload.vue?vue&type=template&id=ff218b30&scoped=true"
import script from "./ProgramDownload.vue?vue&type=script&lang=js"
export * from "./ProgramDownload.vue?vue&type=script&lang=js"
import style0 from "./ProgramDownload.vue?vue&type=style&index=0&id=ff218b30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff218b30",
  null
  
)

export default component.exports